import { Component, ElementRef, OnInit } from "@angular/core"

@Component({
  styleUrls: ['./accordion-fade.scss'],
  template: `
    <mat-card [style.padding]="padding()" [class.no-box-shadow]="!expanded">
      <div class="accordion-fade-container"
        (click)="expanded = !expanded"
        [class.expanded]="expanded"
        style="customStyle">

        <ng-content></ng-content>

        <div class="fade" *ngIf="contentCanExpand()"></div>
      </div>
      <div
        class="accordion-fade-arrow text-center cursor-pointer"
        *ngIf="contentCanExpand()"
        (click)="expanded = !expanded"
        [class.expanded]="expanded">
        <i class="fa text-muted" [ngClass]="{'fa-chevron-up': expanded, 'fa-chevron-down': !expanded}"></i>
      </div>
    </mat-card>
  `,
  selector: 'accordion-fade'
})
export class AccordionFadeComponent implements OnInit {
  expanded: boolean = false;
  queriedHeight: number = 0;
  container: Element;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.container = this.el.nativeElement.querySelector('.accordion-fade-container')
  }

  contentCanExpand(): boolean {
    this.queriedHeight = (this.container && this.container.clientHeight) || 0
    return this.queriedHeight >= 50
  }

  padding(): string {
    return this.expanded ? '10px' : '0px'
  }
}
